<template>
	<!--块级按钮-->
	<button type="button" @click="$emit('click')" class="btn btn-search ft-size-16" :class="classCpt">
		<span>{{btnTxt?btnTxt:'搜索'}}</span>
	</button>
</template>

<script>
	export default{
		inheritAttrs: false, //根元素不继承特性
		props:['classCpt','btnTxt']
	}
</script>

<style scoped>
	.btn-search {
        min-width: 5rem;
        padding:0 1rem;
        line-height: 1.7rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/btnSearch.vue